module.exports = __webpack_public_path__ + "img/logo-zibasoft.872bf820.png";